/* tslint:disable */
import { enableProdMode, NgModuleRef } from '@angular/core';
import { disableDebugTools } from '@angular/platform-browser';
import { Environment } from './model';

enableProdMode();

export const environment: Environment = {
  version: '3.8.3-pre',
  production: true,
  showDevModule: false,
  logs: false,
  itemsPerPage: 30,
  apiRootUrl: 'https://api2.elitment-performance.preview-tokiwi.ch/',
  storageRootUrl: 'https://api2.elitment-performance.preview-tokiwi.ch/storage/',
  appUrl: 'https://elitment-performance2.preview-tokiwi.ch/',
  apiPasswordGrantClient: 2,
  apiPasswordGrantSecret: 'uCh60CP7glYwossmPF6mw8rLt6DWXWeYHiPrX1Nb',
  facebookPageUrl: 'https://facebook.com/tokiwi',
  homepageRedirect: undefined,
  elitmentOrganizationId: 1,
  maintenance: {
    enabled: false,
    titleKey: 'Maintenance_title',
    messageKey: 'Maintenance_message',
    storageKey: 'maintenance-dismissed-2024-10-20'
  },

  /** Angular debug tools in the dev console
   * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
   * @param modRef
   * @return {any}
   */
  decorateModuleRef(modRef: NgModuleRef<any>): any {
    disableDebugTools();
    return modRef;
  },
  ENV_PROVIDERS: [

  ]
};
